/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePhaseDto } from '../../models/response-phase-dto';
import { UpdatePhaseDto } from '../../models/update-phase-dto';

export interface PhasesControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Phase unique ID
 */
  id: string;
  
    /**
     * The phase data to update
     */
    body: UpdatePhaseDto
}

export function phasesControllerUpdate(http: HttpClient, rootUrl: string, params: PhasesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePhaseDto>;
    })
  );
}

phasesControllerUpdate.PATH = '/thalea-pathways/phases/{tenant}/{id}';
